'use client'
import React, { useEffect } from 'react'
import { useTranslations } from 'next-intl'

import { BreadcrumbItem } from './Breadcrumbs'
import { Box, Container } from '@mui/material'
import BreadcrumbsWrapper from '.'

interface BreadcrumbsWrapperProps {
    locale: string
    offerTitle?: string
    isCT?: boolean
}

const BreadcrumbsWrapperComponent: React.FC<BreadcrumbsWrapperProps> = ({offerTitle, locale, isCT }) => {
    const t = useTranslations('common')
    const breadcrumbItems:BreadcrumbItem[] = [
        {
            label: t('offers'),
            isCurrentPage: offerTitle ? false : true,
            href: `/${locale}/offers`
        }
    ]
    if(!!offerTitle){
        breadcrumbItems.push(
            {
                label: offerTitle || 'Offer Details',
                isCurrentPage: true
         })
    }
    return (
        <Box sx={{ px: { xs: 0, sm: 0 } }}>
        <Container maxWidth="xl" sx={{ px: { xs: 0, sm: 2, md: 3 } }}>
            <BreadcrumbsWrapper items={breadcrumbItems} locale={locale} isCT={isCT} />
        </Container>
    </Box>
    )
}

export { BreadcrumbsWrapperComponent }
export type { BreadcrumbItem }